import apiClient from '../apiClient';

/**
 * Fetches the full dashboard summary for the supplier owner.
 * Call on-demand when the user navigates to the dashboard.
 */
export const getDashboardSummary = async () => {
    const response = await apiClient.get('/dashboard/summary');
    return response.data;
};

/**
 * Get tenant statistics (legacy — kept for backward compatibility)
 */
export const getTenantStats = async () => {
    const response = await apiClient.get('/tenants/current/stats');
    return response.data;
};

/**
 * Handle API errors and return user-friendly messages
 */
export const handleApiError = (error) => {
    if (error.response) {
        const status = error.response.status;
        const data = error.response.data;
        switch (status) {
            case 401: return 'Session expired. Please login again.';
            case 403: return 'You do not have permission to view the dashboard.';
            case 500: return 'Server error. Please try again later.';
            default:  return data?.message || 'An error occurred while fetching dashboard data.';
        }
    } else if (error.request) {
        return 'Network error. Please check your connection.';
    }
    return error.message || 'An unexpected error occurred.';
};
